import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { DropdownMenuTrigger as NativeDropdownMenuTrigger } from '../ui/dropdown-menu'

interface DropdownMenuTriggerProps {
  className?: string
  children: ReactNode
  disabled?: boolean
}

export function DropdownMenuTrigger({
  className,
  children,
  disabled = false,
}: DropdownMenuTriggerProps) {
  return (
    <NativeDropdownMenuTrigger
      disabled={disabled}
      className={cn(
        'size-10 data-[state=open]:brightness-110 disabled:cursor-not-allowed flex items-center justify-center rounded-md bg-[#3E54C0] text-white enabled:hover:brightness-110 cursor-pointer duration-200',
        className,
      )}
    >
      {children}
    </NativeDropdownMenuTrigger>
  )
}
